<header class="topbar">
  <div class="header-title-area">
    <!-- Not currently shown — duplicated each page's own eyebrow text below it.
    <div class="eyebrow">PLACEMENT COMMAND CENTER</div>
    -->
    <h1>{{ activePage }}</h1>
    <p>{{ subtitle }}</p>
  </div>

  <div class="header-actions">
    <!-- Academic Year Selector -->
    <app-custom-select
      [value]="academicYear"
      [options]="yearOptions"
      iconType="calendar"
      (valueChange)="yearChange.emit($event)">
    </app-custom-select>

    <!-- Department Selector -->
    <app-custom-select
      [value]="department"
      [options]="deptOptions"
      iconType="graduation"
      (valueChange)="departmentChange.emit($event)">
    </app-custom-select>

    <!-- Officer Profile Dropdown Trigger -->
    <div class="header-control profile-control">
      <div 
        class="header-user" 
        [class.active]="profileMenuOpen" 
        (click)="toggleProfileMenu($event)">
        <div class="avatar small" [class.has-img]="!!collegeLogoUrl">
          <img *ngIf="collegeLogoUrl" [src]="collegeLogoUrl" alt="College Logo" class="college-logo-avatar" />
          <ng-container *ngIf="!collegeLogoUrl">{{ initials }}</ng-container>
        </div>
        <div class="user-meta">
          <strong>{{ placementOfficer }}</strong>
          <span>{{ institutionName }}</span>
        </div>
        <svg class="chevron" [class.rotated]="profileMenuOpen" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <polyline points="6 9 12 15 18 9"/>
        </svg>
      </div>

      <!-- Popover Menu -->
      <div *ngIf="profileMenuOpen" class="popover" (click)="$event.stopPropagation()">
        <div class="popover-header">Account</div>
        <button type="button" class="popover-item" (click)="onProfileClick($event)">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
          <span>Profile</span>
        </button>
        <div class="popover-divider"></div>
        <button type="button" class="popover-item danger" (click)="onSignOutClick($event)">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
          </svg>
          <span>Sign Out</span>
        </button>
      </div>
    </div>
  </div>
</header>
